<script setup>
// En-tête de section : eyebrow (optionnelle) + H2 de la bible + sous-titre gris, centré par défaut.
import BrandTitle from './BrandTitle.vue';
import Eyebrow from './Eyebrow.vue';
defineProps({
  tone: { type: String, default: 'maison' },
  eyebrow: { type: String, default: '' },
  title: { type: String, required: true },
  keyword: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  align: { type: String, default: 'center' },
  as: { type: String, default: 'h2' },
});
</script>

<template>
  <div :class="align === 'center' ? 'text-center max-w-2xl mx-auto' : 'text-left max-w-2xl'">
    <Eyebrow v-if="eyebrow || $slots.eyebrow" :tone="tone" class="mb-3"><slot name="eyebrow" />{{ eyebrow }}</Eyebrow>
    <BrandTitle :as="as" :tone="tone" :text="title" :keyword="keyword" />
    <p v-if="subtitle" class="text-sm md:text-base text-gray-500 leading-relaxed mt-3">{{ subtitle }}</p>
  </div>
</template>
